import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/users/register/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const register = {
  post: apiPathFunc(pathBase),
};
